// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__2Xixa","range":"MonthRangeSwitch_range__3gK1D","disabled":"MonthRangeSwitch_disabled__2ZHDx"};